import React, { Component } from 'react';
import ProjectsEditLayout from './../../templates/projects';
import ProjectEditForm from './../../elements/projects/project';
import Loading from './../../elements/loading';

class ProjectEdit extends Component {
	render (){
		const {projects} = this.props;
		return (
			projects.isFetching ? <Loading message="Cargando..." /> : <ProjectEditForm {...this.props}/>
		);
	}

	componentWillMount() {
		this.props.fetchProjectEdit(this.props.match.params.id);
	}
}

export default ProjectsEditLayout(ProjectEdit, {subnav: 1});



// WEBPACK FOOTER //
// ./src/layouts/projects/project.jsx